import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    LoadRelatedProducts,
} from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";

addToChainAfter(chain, LoadRelatedProducts, props => {
    if (props.getProductCollectionParameter) {
        props.getProductCollectionParameter.expand = props.getProductCollectionParameter?.expand || [];
        props.getProductCollectionParameter?.expand?.push("properties");
    }
});
